import React from 'react';
import { IoMailOutline } from 'react-icons/io5';
import CommonLayout from "../../layouts/CommonLayout";

const CustomerCenterPage = () => {
    return (
        <CommonLayout title="고객센터">
            <div className="p-4 space-y-4 max-w-lg mx-auto">
                {/* 문의하기 */}
                <div className="bg-white rounded-lg border border-gray-200 p-4">
                    <div className="flex items-center mb-3">
                        <IoMailOutline className="text-blue-600 mr-2" size={20} />
                        <h2 className="text-lg font-semibold">문의하기</h2>
                    </div>
                    <p className="text-sm text-gray-600 mb-4 leading-relaxed">
                        밥친구 이용 중 궁금한 사항이나 버그 등의 문제가 있으시면 언제든지 문의해주세요. 밥친구 운영팀이 최대한 빠르게 조치 후 회신 드리겠습니다.
                    </p>
                    <div
                        className="w-full bg-blue-50 border border-blue-200 rounded-lg p-3 flex items-center justify-center"
                    >
                        <IoMailOutline className="text-blue-600 mr-2" size={18} />
                        <span className="text-blue-600 font-medium">singulecorp@gmail.com</span>
                    </div>
                </div>


            </div>
        </CommonLayout>
    );
};

export default CustomerCenterPage;
